import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-contact-list-modal',
  templateUrl: './contact-list-modal.component.html',
  styleUrls: ['./contact-list-modal.component.css']
})
export class ContactListModalComponent {
  @Input() signOffList: any

  constructor(
    private ngbActiveModal: NgbActiveModal,
  ) { }

  closeModal () {
    this.ngbActiveModal.close()
  }
}
